// Core
import {
  Box,
  Text,
  useColorMode,
  useColorModeValue,
  useBreakpointValue
} from '@chakra-ui/react';
import { SunIcon } from '@chakra-ui/icons';

// Assets
import { ReactComponent as MoonIcon } from 'assets/svg/moon.svg';

export default function SwitchTheme() {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === 'dark';
  
  return (
    <Box
      onClick={toggleColorMode}
      cursor="pointer"
      w="85px"
      h="44px"
      bg={isDark ? '#0E1633' : 'white'}
      borderRadius="999px"
      display="flex"
      alignItems="center"
      p="8px"
      transition="all 0.3s ease-out"
      position="relative"
    >
      {isDark ? (
       <SunIcon color="#9FABCB" w={6} h={6} position="absolute" top="10px" left="10px" /> 
      ) : (
       <MoonIcon style={{position: 'absolute', top: '8px', right: '10px'}} />
      )}
      <Box
        pos="absolute"
        w="28px"
        h="28px"
        bg={isDark ? '#9FABCB' : '#7787B0'}
        borderRadius="full"
        transform={`translateX(${isDark ? '40px' : '0px'})`}
        transition="transform 0.3s ease"
      />
    </Box>
  );
}